import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setToast } from '../../store/ToastManagement';
import { Container, Grid, Segment, Button, Header } from 'semantic-ui-react';
import { useCurrentUser } from '../../_services/hooks';
import {
  servicesAPI,
  useLanceToCustomers,
  useCustomerLances
} from '../../_services';
import { history } from '../../_helpers';
import './customerDetail_styles.css';

export const ActivateLance = () => {
  const { customerId } = useCurrentUser();
  const lanceToCustomers = useLanceToCustomers(customerId);
  const lances = useCustomerLances(customerId);

  const [inactiveLanceIds, setInactiveLanceIds] = useState([]);

  const dispatch = useDispatch();
  const displayMessage = (title, message, success) =>
    dispatch(
      setToast({
        title: title,
        success: success,
        body: message
      })
    );

  useEffect(() => {
    if (!lanceToCustomers.length) return;

    const inactiveLanceIds = lanceToCustomers
      .filter(l => l.status === 'ACTIVE' && !l.activated_datetime)
      .map(l => l.lance_tag_id);
    setInactiveLanceIds(inactiveLanceIds);
  }, [lanceToCustomers]);

  return (
    <div>
      <Container>
        <Grid centered padded textAlign="center" style={{ height: '90vh' }}>
          <Grid.Column style={{ maxWidth: 450 }}>
            <Segment>
              <Header as="h2" textAlign="left">
                Activate Lance
              </Header>
              <p>
                Please scan the QR code on the side of your Lance, then return
                here to activate it for use.
              </p>
              <Button
                color="olive"
                onClick={() => {
                  servicesAPI
                    .AdminServices(
                      'getEventsByTypes',
                      'LANCE',
                      'TEST_QR_CODE_SCAN',
                      20 * 60
                    )
                    .then(events => {
                      // Look for recently scanned lances associated with
                      // this customer, which have not yet been activated
                      events.forEach(event => {
                        const serialNo = event.entity_id;
                        const lance = lances.find(
                          l => l.reference === serialNo
                        );
                        const activateLance =
                          lance && inactiveLanceIds.includes(lance.tag_id);

                        if (activateLance) {
                          servicesAPI
                            .CustomerServices('activateLance', lance.tag_id)
                            .then(response => {
                              displayMessage(
                                'Success',
                                'Activation successful, you are ready to charge!',
                                true
                              );
                              history.push('/customer/charging');
                            })
                            .catch(response =>
                              displayMessage(
                                'Error',
                                'Activation failed. If you scanned the QR code, please contact Trojan support and we will help you get started.',
                                false
                              )
                            );
                        }
                      });
                    });
                }}
              >
                ACTIVATE LANCE
              </Button>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
